/*  iceberg-ui  */
import { Box, Foldable } from '@auviknetworks/iceberg-ui';

/*  Table  */
import { CellContext } from '@tanstack/react-table';

/*  Hooks  */
import { Recipient } from 'hooks/dataAccess/Reports/scheduledReports';

/*  Objects  */
import { User, UserFromContext } from 'objects/User';

/* React */
import React from 'react';

/**
 * Renders a list of recipients
 * TODO: better handle the list of recipients, alfabetise and coma separated.
 */
export const RecipientsCell = (props: CellContext<unknown, Recipient[]>) => {
    const recipients = props.cell.getValue();

    if (!recipients || !recipients?.length) {
        return null;
    }

    return (
        <Foldable>
            {recipients.map((recipient) =>
                recipient.type === 'email' ? (
                    <Box key={recipient.value}>{recipient.value}</Box>
                ) : (
                    <User
                        key={recipient.value}
                        includeClients
                        id={recipient.value}
                    >
                        <UserFromContext link />
                    </User>
                )
            )}
        </Foldable>
    );
};
